import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, Loader2, Percent, Package, GraduationCap, ArrowRight, Infinity as InfinityIcon } from "lucide-react";
import { MKT_GOLD, MKT_TINT } from "../../lib/marketplace";
import { apiMembresia } from "../../lib/marketplaceApi";

const PLAN_STYLE = {
  basico: { label: "Básico", color: "#64748B", tint: "#F1F5F9" },
  pro: { label: "Pro", color: "#2563EB", tint: "#EFF4FF" },
  elite: { label: "Elite", color: "#B45309", tint: "#FEF3C7" },
};

function Limite({ Icon, titulo, data }) {
  const pct = data.ilimitado ? 0 : Math.min(100, data.max ? (data.usados / data.max) * 100 : 0);
  const color = pct >= 90 ? "#DC2626" : pct >= 70 ? "#D97706" : MKT_GOLD;
  return (
    <div className="rounded-xl border border-slate-100 bg-slate-50 p-3" data-testid={`membresia-${titulo.toLowerCase()}`}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold text-slate-500 inline-flex items-center gap-1.5"><Icon size={14} /> {titulo} publicados</span>
        <span className="text-sm font-bold text-slate-800">
          {data.ilimitado ? (<span className="inline-flex items-center gap-1"><InfinityIcon size={14} /> Ilimitado</span>) : `${data.usados} / ${data.max}`}
        </span>
      </div>
      {!data.ilimitado && (
        <>
          <div className="mt-2 h-2 w-full rounded-full bg-slate-200 overflow-hidden">
            <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, backgroundColor: color }} />
          </div>
          <p className="mt-1 text-[11px] text-slate-400">{data.disponibles} disponible(s)</p>
        </>
      )}
    </div>
  );
}

export default function MembresiaCard() {
  const [m, setM] = useState(undefined);
  useEffect(() => { apiMembresia().then(setM).catch(() => setM(null)); }, []);

  if (m === undefined) {
    return <div className="rounded-2xl border border-slate-200 bg-white shadow-soft p-5 flex items-center gap-2 text-slate-500" data-testid="membresia-loading"><Loader2 className="animate-spin" size={16} /> Cargando membresía…</div>;
  }
  if (!m) return null;

  const st = PLAN_STYLE[m.plan] || PLAN_STYLE.basico;

  return (
    <section className="rounded-2xl border border-slate-200 bg-white shadow-soft p-5" data-testid="membresia-card">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: st.tint, color: st.color }}>
            <Crown size={20} />
          </span>
          <div>
            <p className="text-xs text-slate-500">Tu plan de membresía</p>
            <h3 className="text-lg font-extrabold" style={{ color: st.color }} data-testid="membresia-plan">Plan {m.plan_label}</h3>
          </div>
        </div>
        <div className="text-right">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-bold" style={{ backgroundColor: MKT_TINT, color: MKT_GOLD }} data-testid="membresia-comision">
            <Percent size={14} /> Comisión {m.comision_pct}%
          </span>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Limite Icon={Package} titulo="Productos" data={m.productos} />
        <Limite Icon={GraduationCap} titulo="Cursos" data={m.cursos} />
      </div>

      <Link to="/planes" data-testid="membresia-ver-planes" className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold hover:gap-2.5 transition-all" style={{ color: MKT_GOLD }}>
        Planes y Membresías <ArrowRight size={15} />
      </Link>
    </section>
  );
}
